
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TmMoodPickersComponent } from "../../../../shared/ui/moodpickers/mood-pickers.component";
import { Mood, TimelineItem } from "@teammood/timeline";
import { debounceTime, filter, Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: 'mood-request-form',
    templateUrl: 'mood-request-form.component.html',
    styleUrls: ['./mood-request-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    FormsModule,
    TmMoodPickersComponent,
    ReactiveFormsModule
]
})
export class MoodRequestFormComponent implements OnInit, OnDestroy {

    @Input() item: Mood;
    @Input() teamId: string;

    protected moodCommentCtrl = new FormControl<string>('');

    codeOfConductLabel: string;

    private _destroy$ = new Subject<void>();

    constructor(
        private translateService: TranslateService,
        private element: ElementRef
    ) { } 
    
    ngOnInit(): void {
        this.moodCommentCtrl.setValue(this.item.comment?.body);

        this.moodCommentCtrl.valueChanges.pipe(
            debounceTime(400),
            filter(moodComment => !!moodComment),
            tap(moodComment=> {
                this.item.comment = {
                    body: moodComment,
                    linkPreviews: []
                };
            }),
            takeUntil(this._destroy$)
        ).subscribe();

        const inputSelector = '.mood-request-input'
        const moodRequestInput = this.element.nativeElement.querySelector(inputSelector);
        this.codeOfConductLabel = this.translateService.instant('add_mood_box.code_of_conduct')
        moodRequestInput.focus();
    }


    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    deleteComment(){
        this.item.comment.body = '';
        this.moodCommentCtrl.setValue('');
    }

    fromMoodPicker (element: string) {
        if (this.item.comment && this.item.comment.body) {
            this.moodCommentCtrl.setValue(this.item.comment.body + ' ' + element);
        } else {
            this.moodCommentCtrl.setValue(element);
        }
    }    
       
}